var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1332 21.0697L21.9271 3.78507C22.2828 2.72392 21.2761 1.71718 20.215 2.07287L2.93032 7.86651C1.77377 8.25417 1.669 9.84965 2.76553 10.3759L9.67563 13.6919C9.95229 13.8246 10.1753 14.0476 10.308 14.3243L13.6239 21.2344C14.1501 22.331 15.7456 22.2262 16.1332 21.0697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.218f1fa341b1002904ef57c3c44a4fd7.svg";
export { ForwardRef as ReactComponent };